"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputField = void 0;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactToString = _interopRequireDefault(require("react-to-string"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _FormField = require("../FormField/_FormField");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _normalizeDoubleByteToStandard = require("../utils/normalizeDoubleByteToStandard");
var _isFunction = require("../utils/isFunction");
var _useUniqueId = require("../utils/useUniqueId");
var _useOverflowDetector2 = require("../utils/useOverflowDetector");
var _CharacterCounter = require("./_CharacterCounter");
var _excluded = ["characterCounter", "decorators", "disabled", "disableInternalValueStateMgmt", "inputDescribedby", "inputProps", "inputRef", "inputType", "label", "onBlur", "onChange", "onFocus", "placeholder", "readOnly", "required", "value", "enableUnicodeNormalization", "size", "unicodeNormalizationForm"],
  _excluded2 = ["characterLimit", "allowEntryOverCharacterLimit", "onCharacterLimitStateChange"],
  _excluded3 = ["inputClassName", "theme", "isFocused"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * **InputField** is used to gather input from a user. It emits an `<input>` element.
 *
 * > This component is designed to replace all usages of **FormGroup**, **InputGroup**,
 * **FormControl** and **ControlLabel**.
 */
var InputField = exports.InputField = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context2, _context3;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(InputField, _props)) : _props;
  var characterCounter = props.characterCounter,
    decorators = props.decorators,
    disabled = props.disabled,
    disableInternalValueStateMgmt = props.disableInternalValueStateMgmt,
    inputDescribedby = props.inputDescribedby,
    inputProps = props.inputProps,
    inputRef = props.inputRef,
    inputType = props.inputType,
    label = props.label,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    placeholder = props.placeholder,
    readOnly = props.readOnly,
    required = props.required,
    value = props.value,
    enableUnicodeNormalization = props.enableUnicodeNormalization,
    size = props.size,
    unicodeNormalizationForm = props.unicodeNormalizationForm,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _ref = characterCounter || {},
    characterLimit = _ref.characterLimit,
    allowEntryOverCharacterLimit = _ref.allowEntryOverCharacterLimit,
    onCharacterLimitStateChange = _ref.onCharacterLimitStateChange,
    otherCharacterCounterProps = (0, _objectWithoutProperties2.default)(_ref, _excluded2);
  var classnames = _bind.default.bind({});
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    limitExceeded = _useState2[0],
    setLimitExceeded = _useState2[1];
  var _useState3 = (0, _react.useState)(value),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    inputValue = _useState4[0],
    setInputValue = _useState4[1];
  var charCountDecoratorId = (0, _useUniqueId.useUniqueId)();
  var internalInputRef = (0, _react.useRef)();
  var mergedInputRef = (0, _reactMergeRefs.default)([internalInputRef, inputRef]);
  var _useOverflowDetector = (0, _useOverflowDetector2.useOverflowDetector)(internalInputRef, [inputValue]),
    checkOverflow = _useOverflowDetector.checkOverflow,
    hasOverflow = _useOverflowDetector.hasOverflow;
  var inputId = (0, _useUniqueId.useUniqueId)();
  if (inputProps !== null && inputProps !== void 0 && inputProps.id) inputId = inputProps.id;
  var handleTextSizeLimit = function handleTextSizeLimit(text) {
    var inputValueLength = (text === null || text === void 0 ? void 0 : text.length) || 0;
    var validatedText = text;
    if (inputValueLength > characterLimit) {
      if (!allowEntryOverCharacterLimit) {
        validatedText = (0, _slice.default)(text).call(text, 0, characterLimit);
        setLimitExceeded(false);
      } else {
        setLimitExceeded(true);
      }
    } else {
      setLimitExceeded(false);
    }
    return validatedText;
  };
  (0, _react.useEffect)(function () {
    setInputValue(handleTextSizeLimit(value));
  }, [value]);
  (0, _react.useEffect)(function () {
    if ((0, _isFunction.isFunction)(onCharacterLimitStateChange)) {
      onCharacterLimitStateChange(limitExceeded);
    }
  }, [limitExceeded]);
  var handleBlur = function handleBlur(e) {
    if ((0, _isFunction.isFunction)(onBlur)) {
      onBlur(e);
    }
  };
  var handleChange = function handleChange(e) {
    var _e$target, _e$target2;
    checkOverflow === null || checkOverflow === void 0 || checkOverflow();
    var inputValueLength = (e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 || (_e$target = _e$target.value) === null || _e$target === void 0 ? void 0 : _e$target.length) || 0;
    if (!characterLimit || Boolean(allowEntryOverCharacterLimit) || inputValueLength <= characterLimit ||
    // this last condition is to handle pasting text
    // and just letting the useEffect handling
    // truncating the string
    (e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.selectionStart) > characterLimit) {
      var _e$target3;
      setInputValue(handleTextSizeLimit(e === null || e === void 0 || (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.value));
      if ((0, _isFunction.isFunction)(onChange)) {
        onChange(e);
      }
    }
  };
  var handleFocus = function handleFocus(e) {
    if ((0, _isFunction.isFunction)(onFocus)) {
      onFocus(e);
    }
  };
  var getHeadingEndDecorators = function getHeadingEndDecorators() {
    var _context;
    if (!characterLimit) {
      return decorators === null || decorators === void 0 ? void 0 : decorators.headingEnd;
    }
    return (0, _concat.default)(_context = [/*#__PURE__*/_react.default.createElement(_CharacterCounter.CharacterCounter, (0, _extends2.default)({}, otherCharacterCounterProps, {
      id: charCountDecoratorId,
      characterLimit: characterLimit,
      currentInputLength: disableInternalValueStateMgmt ? value.length : inputValue === null || inputValue === void 0 ? void 0 : inputValue.length,
      size: size
    }))]).call(_context, (0, _toConsumableArray2.default)(_react.default.Children.toArray(decorators === null || decorators === void 0 ? void 0 : decorators.headingEnd)));
  };

  /** HandleComposition handles input that contains double-byte(JP,CN,KR, etc)
   * characters and standardizes them when the composition ends.  */
  var handleComposition = function handleComposition(e) {
    e.target.value = (0, _normalizeDoubleByteToStandard.normalizeDoubleByteToStandard)(e.target.value, unicodeNormalizationForm);
    handleChange(e);
  };
  var renderInput = (0, _react.useCallback)(function (_ref2) {
    var _internalInputRef$cur;
    var inputClassName = _ref2.inputClassName,
      theme = _ref2.theme,
      isFocused = _ref2.isFocused,
      attributes = (0, _objectWithoutProperties2.default)(_ref2, _excluded3);
    var isiOS = theme.indexOf('_ios') >= 0;
    var inputClasses = classnames(inputClassName, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className);
    var getPlaceholderText = function getPlaceholderText() {
      if (isiOS && !disabled) {
        return (0, _reactToString.default)(label);
      }
      if (placeholder && !readOnly && !disabled) {
        return placeholder;
      }
      return undefined;
    };
    var showOverflowTitle = inputType !== 'password' && hasOverflow && (!isFocused || readOnly || disabled);
    var overflowTitle = showOverflowTitle ? (disableInternalValueStateMgmt ? value : inputValue) || ((_internalInputRef$cur = internalInputRef.current) === null || _internalInputRef$cur === void 0 ? void 0 : _internalInputRef$cur.value) : undefined;
    return /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
      title: overflowTitle
    }, inputProps, attributes, {
      onKeyDown: (0, _chainFunction.default)(inputProps === null || inputProps === void 0 ? void 0 : inputProps.onKeyDown, attributes === null || attributes === void 0 ? void 0 : attributes.onKeyDown),
      "aria-required": required,
      className: inputClasses,
      disabled: disabled,
      id: inputId,
      placeholder: getPlaceholderText(),
      readOnly: readOnly,
      ref: mergedInputRef,
      type: inputType,
      value: disableInternalValueStateMgmt ? value : inputValue,
      onBlur: handleBlur,
      onCompositionEnd: enableUnicodeNormalization ? (0, _chainFunction.default)(inputProps === null || inputProps === void 0 ? void 0 : inputProps.onCompositionEnd, handleComposition) : inputProps === null || inputProps === void 0 ? void 0 : inputProps.onCompositionEnd,
      onChange: handleChange,
      onFocus: handleFocus
    }));
  }, [inputProps, disabled, readOnly, placeholder, hasOverflow, inputValue]);
  var describedbyString;
  if (typeof inputDescribedby === 'string') {
    describedbyString = inputDescribedby;
  } else if (Array.isArray(inputDescribedby)) {
    var _inputDescribedby$joi;
    describedbyString = (_inputDescribedby$joi = inputDescribedby.join) === null || _inputDescribedby$joi === void 0 ? void 0 : _inputDescribedby$joi.call(inputDescribedby, ' ');
  }
  return /*#__PURE__*/_react.default.createElement(_FormField.FormField, (0, _extends2.default)({}, otherProps, {
    inputDescribedby: characterLimit ? (0, _trim.default)(_context2 = (0, _concat.default)(_context3 = "".concat(describedbyString || '', " ")).call(_context3, charCountDecoratorId)).call(_context2) : describedbyString,
    type: inputType,
    decorators: _objectSpread(_objectSpread({}, decorators), {}, {
      headingEnd: getHeadingEndDecorators()
    }),
    disabled: disabled,
    inputId: inputId,
    label: label,
    readOnly: readOnly,
    ref: ref,
    renderInput: renderInput,
    required: required,
    canTruncate: hasOverflow,
    noTruncationOnFocus: true,
    size: size
  }));
});
InputField.displayName = 'InputField';
InputField.propTypes = _objectSpread(_objectSpread({}, _FormField.FormField.propTypes), {}, {
  /** @ignore, prop is only for FormField */
  inputId: _CustomPropTypes.default.notDefined,
  /** @ignore, prop is only for FormField */
  renderInput: _CustomPropTypes.default.notDefined,
  /**
   *
   * `characterLimit`: Maximum characters allowed within input element
   *
   *
   * `allowEntryOverCharacterLimit`:  Set to true to continue allowing additional
   * characters past the `characterLimit`. This character counter will show the user
   * when they have exceeded the limit.
   *
   * `onCharacterLimitStateChange` `(limitExceeded) => boolean`:
   * Callback function when the character limit state changes.
   * This only applies when `allowEntryOverCharacterLimit` is true.
   *
   * `localizedText`: Localized text to be updated based on location/language:
   *
   * `counterTooltipMessage`: Localized string to display in the character
   * counter tooltip. Available as `CoreUIComponents.counterTooltipMessage`.
   *
   * `exceededCountWarning`: Localized string to display in the tooltip when
   * the character limit has been exceeded. Available as `CoreUIComponents.exceededCountWarning`.
   *
   * `iconProps`: additional props to spread to the validation **Icon** component.
   */
  characterCounter: _propTypes.default.shape({
    localizedText: _propTypes.default.shape({
      counterTooltipMessage: _CustomPropTypes.default.localizedString('CoreUIComponents.counterTooltipMessage').isRequired,
      exceededCountWarning: _CustomPropTypes.default.localizedString('CoreUIComponents.exceededCountWarning').isRequired
    }).isRequired,
    characterLimit: _propTypes.default.number,
    allowEntryOverCharacterLimit: _propTypes.default.bool,
    onCharacterLimitStateChange: _propTypes.default.func,
    iconProps: _propTypes.default.object
  }),
  /** @ignore, prop is only for Combobox/multicombobox */
  disableInternalValueStateMgmt: _propTypes.default.bool,
  /** Additional props to spread to the `<input>` element. */
  inputProps: _propTypes.default.object,
  /** Attach a ref to the `<input>` element. */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /** Define the `type` attribute of the `<input>` element. */
  inputType: _propTypes.default.string,
  /** Placeholder displayed when input field is empty. */
  placeholder: _propTypes.default.string,
  /** Set to **true** to enable unicode normalization of input value. */
  enableUnicodeNormalization: _propTypes.default.bool,
  /** Unicode normalization form: https://unicode.org/reports/tr15/#Norm_Forms
   * `'NFD' | 'NFC' | 'NFKD' | 'NFKC'`
   */
  unicodeNormalizationForm: _propTypes.default.oneOf(_normalizeDoubleByteToStandard.UNICODE_NORMALIZATION_FORMS),
  /** The value of the input field. */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
});
InputField.defaultProps = _objectSpread(_objectSpread({}, _FormField.FormField.defaultProps), {}, {
  inputType: 'text',
  value: '',
  unicodeNormalizationForm: 'NFC'
});
var _default = exports.default = InputField;